export default "__VITE_ASSET__ba4252b0__"